import { CSSProperties } from 'react';
import { FieldError } from 'react-hook-form-mui';
import { Location } from 'react-router-dom';
import { EmailSentIcon, TypingGirlIcon, SetUpProfileGirlIcon } from 'assets';
import HeadingWelcomeCircle from 'assets/images/heading_welcome_circle.svg';
import HeadingVerifyCircle from 'assets/images/heading_verify_circle.svg';
import HeadingCheckCircle from 'assets/images/heading_check_circle.svg';
import HeadingCreateCircle from 'assets/images/heading_create_circle.svg';
import { InputErrorWithIcon } from 'view/components';

const AuthHeadingEnums = {
  WELCOME: 'Welcome',
  VERIFY: 'Verify',
  CREATE: 'Create',
  CHECK: 'Check',
};

export const AuthHeadingImageTypeEnums = {
  CIRCLE: 'circle',
  LINE: 'line',
} as const;

export const getRightBlockIcon = (location: Location) => {
  switch (location.pathname) {
    case '/auth/forgot/check-email':
      return <EmailSentIcon />;
    case '/auth/registration/verify-email':
      return <EmailSentIcon />;
    case '/auth/choose-your-role':
      return <SetUpProfileGirlIcon />;
    default:
      return <TypingGirlIcon />;
  }
};

export const stylesObj: { [key: string]: CSSProperties } = {
  [AuthHeadingEnums.WELCOME]: {
    position: 'absolute',
    width: '115%',
    height: '2.2em',
    left: '-28px',
    top: '-30px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.VERIFY]: {
    position: 'absolute',
    width: '125%',
    height: '2.2em',
    left: '-22px',
    top: '-27px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.CHECK]: {
    position: 'absolute',
    width: '120%',
    height: '2.2em',
    left: '-18px',
    top: '-28px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.CREATE]: {
    position: 'absolute',
    width: '120%',
    height: '2.2em',
    left: '-22px',
    top: '-27px',
    objectFit: 'contain',
  },
};

export const stylesObjMobile: { [key: string]: CSSProperties } = {
  [AuthHeadingEnums.WELCOME]: {
    position: 'absolute',
    width: '115%',
    height: '2.2em',
    left: '-17px',
    top: '-20px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.VERIFY]: {
    position: 'absolute',
    width: '125%',
    height: '2.2em',
    left: '-17px',
    top: '-19px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.CHECK]: {
    position: 'absolute',
    width: '120%',
    height: '2.2em',
    left: '-13px',
    top: '-19px',
    objectFit: 'contain',
  },
  [AuthHeadingEnums.CREATE]: {
    position: 'absolute',
    width: '120%',
    height: '2.2em',
    left: '-15px',
    top: '-18px',
    objectFit: 'contain',
  },
};

export const stylesLineObj: CSSProperties = {
  position: 'absolute',
  width: '100%',
  left: '0',
  bottom: '-5px',
  objectFit: 'contain',
};

export const imagesObj: {
  [key: string]: {
    imageUrl: string;
  };
} = {
  [AuthHeadingEnums.WELCOME]: {
    imageUrl: HeadingWelcomeCircle,
  },
  [AuthHeadingEnums.VERIFY]: {
    imageUrl: HeadingVerifyCircle,
  },
  [AuthHeadingEnums.CHECK]: {
    imageUrl: HeadingCheckCircle,
  },
  [AuthHeadingEnums.CREATE]: {
    imageUrl: HeadingCreateCircle,
  },
};

export const parseError = (error: FieldError) => {
  return <InputErrorWithIcon errorText={error.message || 'Unknown error'} />;
};

export const commonEmailValidationRules = {
  required: 'Email is required',
  pattern: {
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    message: 'Invalid email address',
  },
};

export const getCommonPasswordValidationRules = (fieldName: string) => {
  return {
    required: `${fieldName} is required`,
    minLength: {
      value: 8,
      message: `${fieldName} must be longer than 8 characters.`,
    },
    maxLength: {
      value: 64,
      message: `${fieldName} must be less than 64 characters`,
    },
    pattern: {
      value: /^[A-Za-z0-9~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]+$/,
      message: `The ${fieldName} may contain Latin letters, numbers and some special characters.`,
    },
  };
};
